import { Component, OnInit } from '@angular/core';
import { config } from '../../../config';

@Component({
  selector: 'ngx-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  serverUrl = config.serverUrl;
  imageUrl = config.imageUrl;
  
  constructor() { }

  ngOnInit() {
  }

}
